export default __webpack_public_path__ + "static/mapa-bac4db62d25f1006cf2ef6fe1f45a57d.png";